<template>
    <div class="permission">
        <div style="display: flex;">
            <label style="display: block; position: relative; color: #000; font-size: 16px; top: -1px; user-select: none;">
                <div class="right" style="float: right;">
                    <template v-for="role in computedRoles">&nbsp;<span class="label bg-gray">{{ role.description }}</span></template>
                </div>

                <input v-if="permission.permissions"
                       type="checkbox"
                       :value="permission.permissions"
                       @change.stop.prevent="togglePermission(permission)"
                       :checked="isChecked"
                       style="z-index: 1">
                <span :class="{bold: isChecked}">{{ permission.text }}</span>

                <input v-if="permissionInRoles"
                       type="checkbox"
                       checked
                       disabled
                       style="position: absolute;
                   z-index: 0;
                   left: 0; opacity:0.5;" />
            </label>

            <template v-if="isRoot && permission.inner?.length">
                <i class="fa fa-fw fa-chevron-right" @click="expand" v-show="isCollapsed" style="cursor: pointer"/>
                <i class="fa fa-fw fa-chevron-down" @click="collapse" v-show="!isCollapsed" style="cursor: pointer"/>
            </template>
        </div>

        <div v-show="!isCollapsed" v-for="innerPermission in permission.inner" class="permission" style="padding-left: 40px;">
            <permission-with-roles
                :permission="innerPermission"
                :roles="roles"
                v-model="currentPermissions"
                @checked="check"
                :key="innerPermission.permissions"></permission-with-roles>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default {
    name: 'permission-with-roles',
    props: {
        permission: {
            type: Object,
            required: false
        },
        userPermission: {
            type: Array,
            required: true,
        },
        roles: {
            type: Array,
            required: true,
        },
        isRoot: {
            type: Boolean,
            default: false,
        }
    },
    model: {
        prop: 'userPermission',
        event: 'change'
    },
    data () {
        return {
            currentPermissions: this.userPermission,
            isCollapsed: this.isRoot,
        };
    },

    computed: {
        hasPermission () {
            return this.currentPermissions.includes(this.permission.permissions);
        },
        isChecked () {
            return this.hasPermission;
        },
        permissionInRoles () {
            return this.computedRoles.length > 0;
        },
        computedRoles () {
            let roles = this.roles.filter((role) => {
                let index = role.permissions.indexOf(this.permission.permissions);
                if (index > -1) {
                    return true;
                }
                return false;
            });

            return roles;
        }
    },

    methods: {
        togglePermission() {
            if (this.hasPermission) {
                this.uncheck();
            } else {
                this.check()
            }
        },
        check (silent) {
            if (!this.hasPermission) {
                this.currentPermissions.push(this.permission.permissions);
            }
            if (silent !== true) {
                this.$emit('change', this.currentPermissions);
                this.$emit('checked', this.currentPermissions);
            }
        },
        uncheck (silent) {
            let index = this.currentPermissions.indexOf(this.permission.permissions);
            if (index > -1) {
                this.currentPermissions.splice(index, 1);
            }
            if (silent !== true) {
                this.$emit('change', this.currentPermissions);
            }

            this.$children.forEach((item, index) => {
                item.uncheck(silent);
            })
        },
        collapse() {
            this.isCollapsed = true;
        },
        expand() {
            this.isCollapsed = false;
        }
    },

    watch: {
    }
}
</script>

<style lang="scss">
#userDialog {
    width: 700px;

    span.bold {
        font-weight: bolder;
    }
}
</style>
